<template>
  <NuxtLink
    :to="app.link"
    :title="`Download ${app.os} App`"
    target="_blank"
    rel="noopener noreferrer"
  >
    <NuxtImg
      :class="{
        'max-mobile:h-[40px]': !fixedHeight,
      }"
      :src="`/images/${app.os}-${locale}.svg`"
      width="200"
      :height="badgeHeight"
      :alt="`${app.os} app store badge`"
      :loading="loading"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  app: App
  loading?: 'lazy'
  fixedHeight?: Boolean
}>()
const { locale } = useI18n()
const badgeHeight = props.app.os === 'android' ? 59 : 66
</script>
